import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL, // URL dynamique basée sur l'environnement
});

const publicRoutes = [
    '/tournois',    
];

// Add request interceptor
api.interceptors.request.use(
    (config) => {
        // Skip token check for public routes
        const isPublicRoute = publicRoutes.some(route => 
            config.url?.includes(route)
        );

        if (!isPublicRoute) {
            const token = sessionStorage.getItem('accessToken');
            if (token) {              
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
  
  // Add response interceptor for handling token expiration
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        sessionStorage.removeItem('accessToken');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );

export default api;
